import { Search, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StatsBar } from './StatsBar';

export function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(`/opportunities?search=${encodeURIComponent(searchQuery)}`);
  };

  return (
    <section className="relative min-h-[85vh] flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="/images/brazzaville-bridge-enhanced.jpg" 
          alt="Pont de Brazzaville" 
          className="w-full h-full object-cover"
          loading="eager"
          fetchPriority="high"
          decoding="async"
          sizes="100vw"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/80 to-slate-900/60" />
      </div>
      
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-3xl">
          {/* Eyebrow */}
          <div className="inline-flex items-center gap-2 mb-6">
            <span className="w-12 h-[2px] bg-honor-orange" />
            <span className="text-honor-orange font-medium tracking-wide uppercase text-sm">
              Brazzaville, Congo
            </span>
          </div>
          
          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-[0.95] tracking-tight">
            Trouvez votre
            <br />
            <span className="text-honor-orange">prochaine</span>
            <br />
            opportunité
          </h1>
          
          <p className="text-xl md:text-2xl text-white/80 mb-10 max-w-xl leading-relaxed font-light">
            Emplois, stages, bourses et formations pour les talents congolais.
          </p>
          
          {/* Search Bar */}
          <form onSubmit={handleSearch} className="mb-8">
            <div className="flex flex-col sm:flex-row gap-3 max-w-xl">
              <div className="relative flex-1">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
                <Input
                  type="text"
                  placeholder="Rechercher une opportunité..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-12 h-14 text-base bg-white border-0 rounded-lg shadow-lg focus-visible:ring-2 focus-visible:ring-honor-orange"
                />
              </div>
              <Button 
                type="submit" 
                size="lg" 
                className="h-14 px-8 bg-honor-orange hover:bg-honor-orange/90 text-white font-semibold rounded-lg shadow-lg transition-all hover:shadow-xl"
              >
                Rechercher
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </div>
          </form>
          
          {/* Stats */}
          <StatsBar />
        </div>
      </div>
    </section>
  );
}
